import React, { useState } from 'react'
import ReturnTypeBulkActions from './MoviesList/ReturnTypeBulkActions'
import { ToastStyle } from '../Data/MovieStaticData'
import { toast } from 'react-toastify'
// import DeleteMovieList from '../../Services/Mutations/DeleteMovieList'
import UpdateMovieListStatusService from '../../Services/Mutations/UpdateMovieListStatusService'

function BulkActionsMoviesList(props) {
  const {
    setServiceData,
    setCheckBoxArr,
    checkBoxArr,
    serviceData,
    checkSelectedArrayLength,
    status,
    BulkActionPermission,
  } = props
  const [selectedValue, setSelectedValue] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  const HandleSelectedValue = e => {
    setSelectedValue(e.target.value)
  }

  const applyFunction = async event => {
    console.log(event.target.value, 'indidebulk')
    setIsLoading(true)

    checkBoxArr.map(async item => {
      const publishedListUpdate = {
        PK: item.PK,
        SK: item.SK,
      }
      const DeleteMovie = await UpdateMovieListStatusService({
        movieListID: item.SK,
        status: selectedValue,
      })
      const remainingElements =
        serviceData && serviceData.filter(elem => !checkBoxArr.find(({ SK }) => elem.SK === SK))
      const statusCodevalue = DeleteMovie.statusCode

      if (statusCodevalue === 'M022') {
        // console.log('deeeeeeeeee')
        setServiceData(remainingElements)
        toast.success(DeleteMovie.statusMessage, ToastStyle)
      }

      setSelectedValue('')
      return publishedListUpdate
    })

    setCheckBoxArr([])
    setIsLoading(false)
  }

  return (
    <div>
      <ReturnTypeBulkActions
        HandleSelectedValue={HandleSelectedValue}
        selectedValue={selectedValue}
        checkSelectedArrayLength={checkSelectedArrayLength}
        isLoading={isLoading}
        applyFunction={applyFunction}
        status={status}
        BulkActionPermission={BulkActionPermission}
      />
    </div>
  )
}

export default BulkActionsMoviesList
